// require('expose?pdfMake!pdfmake/build/pdfmake.min.js')
// require('imports-loader?this=>window!pdfmake/build/vfs_fonts.js')
import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/fr'
import 'moment/locale/de'
require('pdfmake/build/pdfmake.min.js')
require('pdfmake/build/vfs_fonts.js')

function getLogo () {
  let logoMaxima = document.getElementById('logo-maxima')
  let canvas = document.createElement('canvas')
  if (logoMaxima) {
    canvas.width = logoMaxima.width
    canvas.height = logoMaxima.height
    canvas.getContext('2d').drawImage(logoMaxima, 0, 0)
  }
  return canvas.toDataURL('image/png')
}

let generatePdf = function (order, vm) {
  console.log('Generate PDF')
  // date and time when the pdf was generated
  let date = new Date()
  date = moment(date).locale(Vue.config.language).format('L LT')

  let containsCustom = false
  let products = []

  for (let i = 0; i < order.products.length; i++) {
    containsCustom = containsCustom || order.products[i].custom
    products.push([order.products[i].name, order.products[i].quantity, (order.products[i].price === 0) ? '' : order.products[i].price + '€'])
  }
  let total = (containsCustom) ? '*' + vm.$gettext('TOTAL: (incl. VAT)') : vm.$gettext('TOTAL: (incl. VAT)')

  let info = {}
  if (containsCustom) {
    info = {
      text: vm.$gettext('*The price does not include custom products'),
      italics: true,
      fontSize: 10
    }
  }

  let docDefinition = {
    content: [
      {
        image: getLogo(),
        style: 'header',
        width: 300
      },
      {
        style: 'tableUrl',
        table: {
          widths: ['*', 'auto', '*'],
          body: [
            [{
              border: [false],
              text: ' '
            }, {
              border: [false],
              text: 'TEL. + 352/507997\twww.maxima.lu'
            }, {
              border: [false],
              fontSize: 18,
              alignment: 'right',
              text: order.customerId || ''
            }]
          ]
        }
      },
      {
        style: 'tableName',
        table: {
          widths: ['*', 'auto', '*'],
          body: [
            [{
              border: [false],
              text: ' '
            }, {
              text: vm.$gettext('Dry Cleaning - Laundry'),
              fontSize: 15
            }, {
              border: [false],
              fontSize: 18,
              alignment: 'right',
              text: `${('000000' + order.orderId).slice(-6)}`
            }]
          ]
        }
      },
      {
        style: 'tableAddress',
        table: {
          widths: ['*', '*'],
          body: [
            [
              { text: vm.$gettext('DEPOT:'), alignment: 'right' },
              { text: `${order.customer}`, alignment: 'left' }
            ],
            [
              { text: vm.$gettext('CLIENT:'), alignment: 'right' },
              { text: `${order.name}`, alignment: 'left' }
            ],
            [
              { text: vm.$gettext('ORDER:'), alignment: 'right' },
              { text: `#${('000000' + order.orderId).slice(-6)}`, alignment: 'left' }
            ],
            [
              { text: vm.$gettext('ADDRESS:'), alignment: 'right' },
              { text: `${order.address.street}\n${order.address.postcode} ${order.address.city}\n${order.address.country}`, alignment: 'left' }
            ],
            [
              { text: vm.$gettext('DATE:'), alignment: 'right' },
              { text: `${order.date}`, alignment: 'left' }
            ]
          ]
        },
        layout: 'noBorders'
      },
      {
        style: 'tableProducts',
        table: {
          widths: ['*', 105, 100],
          body: [
            [
              {text: vm.$gettext('Product'), style: 'tableHeader'},
              {text: vm.$gettext('Quantity'), style: 'tableHeader'},
              {text: vm.$gettext('Price (incl. VAT)'), style: 'tableHeader'}
            ],
            ...products,
            [
              { text: ' ', border: [false] },
              total,
              `${order.totalPrice} €`
            ]
          ]
        },
        layout: {
          paddingLeft (i, node) { return 6 },
          paddingRight (i, node) { return 6 },
          paddingTop (i, node) { return 6 },
          paddingBottom (i, node) { return 6 }
        }
      },
      info,
      {
        text: vm.$gettext('Note: ') + order.note,
        margin: [0, 20, 0, 5]
      }
    ],
    footer: {
      fontSize: 10,
      columns: [
        vm.$gettext('User: ') + order.email,
        {
          alignment: 'right',
          text: vm.$gettext('Generated: ') + date
        }
      ],
      margin: [40, 0]
    },
    styles: {
      header: {
        fontSize: 40,
        bold: true,
        alignment: 'center'
      },
      subheader: {
        fontSize: 12,
        bold: true,
        alignment: 'center'
      },
      tableUrl: {
        margin: [0, 10, 0, 5],
        alignment: 'center'
      },
      tableName: {
        margin: [0, 0, 0, 15],
        alignment: 'center'
      },
      tableAddress: {
        margin: [0, 5, 0, 15],
        border: [false],
        alignment: 'center'
      },
      tableHeader: {
        bold: true,
        fontSize: 13,
        color: 'black'
      },
      tableProducts: {
        margin: [0, 5, 0, 5]
      }
    }
  }
  return docDefinition
}

export default {
  downloadPdf (order, vm) {
    window.pdfMake.createPdf(generatePdf(order, vm)).download()
    console.log('generatePdf - download')
  },
  printPdf (order, vm) {
    window.pdfMake.createPdf(generatePdf(order, vm)).print()
    console.log('generatePdf - print')
  },
  openPdf (order, vm) {
    window.pdfMake.createPdf(generatePdf(order, vm)).open()
    console.log('generatePdf - open')
  }
}



// WEBPACK FOOTER //
// ./src/components/common/OrderPdf.js